import { getIsRequesting } from 'redux/domain/AsyncStatus/selectors';
import { makeZipVerificationKeyPath } from './keyPath';

// eslint-disable-next-line import/prefer-default-export
export const getIsVerifyingZip = (state, asyncId, zipCodeFieldPath = null) => {
	const asyncKeyPath = makeZipVerificationKeyPath(asyncId, zipCodeFieldPath);
	return getIsRequesting(state, asyncKeyPath);
};
